import React, { useEffect, useLayoutEffect, useState } from "react";
import { useSession } from "../utils/Session";
import { formatCount, initialFilters, isLocalStorageAvailable, objectToPath, pathToObject } from "../utils/Utils";
import { apiCall } from "../utils/Api";
import { useHistory, useLocation } from "react-router";
import conditional from "../utils/conditional";
import PreviousRender from "./PreviousRender";
import TitleExtras from "./TitleExtras";
import Pubstock from "./Pubstock";
import BrowseFilters from "./BrowseFilters";
import { Divider, Layout, Segmented, Empty, Select, Skeleton, Space, Col, Tooltip, Spin, Table, Typography, Row } from "antd";
import { AppstoreOutlined, PicLeftOutlined, CalendarOutlined, UnorderedListOutlined } from '@ant-design/icons';
import Title, { TitleTable } from "./Title";
import Paginate from "./Paginate";

export default function Browse() {

    const [session, setSession] = useSession();
    const path = "/browse";
    const [view, setView] = useState("details");
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const init = pathToObject(location.pathname);
    const [filters, setFilters] = useState(init);
    const [f, setF] = useState([]);
    const [results, setResults] = useState({ rows: [] });
    const [pagination, setPagination] = useState(() => {
        const offset = init?.o ?? 0;
        const limit = init?.l ?? 26;

        return {
            current: Math.floor(offset / limit) + 1,
            offset,
            pagesize: limit
        };
    });

    const count = (results.row_count < results.max_offset) ? results.row_count : results.max_offset;


    useLayoutEffect(() => {
        return () => {
            console.log(window.scrollY)
            sessionStorage.setItem("scrollY", window.scrollY);
        };
    }, []);



    const hasData = (_filters) => {
        if (isLocalStorageAvailable()) {
            if (localStorage.getItem("path") === location.pathname) {
                setResults(JSON.parse(localStorage.getItem("data")))
                setLoading(false);
                const y = sessionStorage.getItem("scrollY");
                if (y) {
                    setTimeout(() => {
                        window.scrollTo(0, parseInt(y, 10));
                    }, 10)


                }

                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    const fetchBrowse = () => {


        // if (hasData(filters)) {
        //     return;
        // }

        window.scrollTo(0, 0);





        let _obj = pathToObject(location.pathname);

        if (_obj["t"]) {
            _obj["t"] = _obj["t"].replaceAll("%25", "%");
            _obj["t"] = _obj["t"].replaceAll("%2f", "/");
        }



        // if (!session.has_bestsell && _obj?.t && !_obj?.v) {
        //     history.push({ pathname: path + objectToPath({ ..._obj, "v": "date", "o": 0 }) });
        //     return; 
        // }
        setLoading(true);


        apiCall("browse/get", _obj, (_s, _r) => {
            if (_s) {

                if (isLocalStorageAvailable()) {
                    localStorage.setItem("path", location.pathname);
                    localStorage.setItem("data", JSON.stringify(_r));
                }

                let _status = _r?.filter_info.find(item => item.name === "status");


                if (_r.rows.length === 0 && _status?.selected_rows.includes("active")) {
                    console.log(_obj)
                    console.log(_r)
                    let _p = objectToPath({ ..._obj, "b": [] })
                    setFilters({ ..._obj, "b": [] })
                    history.push("/browse" + _p);
                    return
                }


                setResults(_r);
                setFilters(_obj);
                setF(_r?.filter_info ?? []);
                const offset = _obj?.o ?? 0;
                const limit = _obj?.l ?? 26;
                setPagination({
                    current: Math.floor(offset / limit) + 1,
                    offset,
                    pagesize: limit
                })

            }
            setLoading(false);
        })
    }
    useEffect(fetchBrowse, [location.pathname, session.logged_in]);


    const drawContext = () => {
        if (!results?.context) {
            return;
        }
        let {
            name = "",
            list_id = "",
            type = "",
            header = ""
        } = results.context;
        if (list_id) {

            if (type === "list") {
                return (<p>Viewing products from: <a onClick={() => history.push("/my-lists/filter/t/" + list_id)}>{name}</a></p>)
            } else {
                return (<p>Viewing products from: <a onClick={() => history.push("/catalogues/filter/t/" + list_id)}>{name}</a></p>)
            }



        }
    }


    const drawTitles = () => {

        switch (view) {
            case "list":
                return (<TitleTable list_id={results?.context?.list_id} rows={results.rows} />);
            case "details":
                return results.rows.map(item => {
                    return <div key={item.eisbn} className="summary-link"><Title list_id={results?.context?.list_id} view={view} data={item} /></div>
                })
            case "cards":
                return (
                    <div className="wrapper">{results.rows.map(item => {
                        return <div onClick={(e) => {

                            let el = e.target;
                            while (el && el !== e.currentTarget) {
                                if (el.onclick || el.getAttribute('onClick') || el.dataset.clickable === 'true') {
                                    return;
                                }
                                el = el.parentElement;
                            }

                            history.push("/item/" + item.eisbn)

                        }} key={item.eisbn} className="summary-link"><Title list_id={results?.context?.list_id} view={view} data={item} /></div>
                    })}</div>
                )
            case "calendar":
                return results.rows.map(item => (
                    <div key={item.eisbn}>
                        <div className="shim" /><div className="shim" />
                        <Row gutter={18}>
                            <Col flex={"auto"}>
                                <div style={{ "maxWidth": "570px" }}>
                                    <div className="calendar-title-tag" style={{ textAlign: "center", margin: "10px 0", display: "none", border: "1px solid #d9d9d9" }}>Current Edition</div>
                                    <Title list_id={results?.context?.list_id} view={view} data={item} />
                                </div>
                                <div style={{ "maxWidth": "570px" }}>
                                    <TitleExtras list_id={results?.context?.list_id} titlelist_id={item.titlelist_id} view={view} data={item} />
                                    <Pubstock eisbn={item.eisbn} suppliers={item.pubstock} />
                                </div>
                            </Col>
                            <Col style={{ "maxWidth": "570px", "width": "100%" }}>
                                <div className="calendar-title-tag" style={{ textAlign: "center", margin: "10px 0", display: "none", border: "1px solid #d9d9d9" }}>Previous Edition</div>
                                {item.related_count.previous_edition.count > 0 ? <PreviousRender eisbn={item.eisbn} /> : <div style={{ "height": "200px", "display": "flex", "flexDirection": "column-reverse" }}><Empty description="No previous edition found." image={Empty.PRESENTED_IMAGE_SIMPLE} /></div>}                            </Col>
                        </Row>
                        <div className="shim" /><div className="shim" />
                    </div>
                ));
        }
    }


    const sort = () => {


        if ((!filters?.t && !filters?.x && !filters?.z) && !(session.has_bestsell)) {
            return (<></>)
        }

        return (
            <Space>
                <small className="hide">Sort:</small>
                <Select
                    size="large"
                    value={filters.v}
                    onChange={(value) => {
                        history.push({ pathname: path + objectToPath({ ...filters, "v": value, "o": 0 }) });
                    }}
                    style={{ width: 170 }}
                    className="asa-select"
                    placeholder="Popularity"
                >

                    {((session.has_bestsell || session.has_bm_data_lite || session?.has_bm_data_full) && <Select.Option value="">Popularity</Select.Option>)}
                    <Select.Option value="date">Release date</Select.Option>
                    <Select.Option value="title">Title</Select.Option>
                    {((session.has_bestsell || session.has_bm_data_lite || session?.has_bm_data_full) && <Select.Option value="author">Author</Select.Option>)}
                    {(results?.context && <Select.Option value="sequence">Sequence</Select.Option>)}
                </Select>
            </Space>
        )
    }


    return (
        <div className="container" style={{ "minHeight": "calc(100vh - 450px)" }}>
            <div className="float-flex">
                <Space align="center"><Typography.Title style={{ "marginBottom": "6px" }} level={4}>Browse</Typography.Title><span style={{ "fontSize": "14px", "opacity": "0.8" }}>({formatCount(results?.row_count ?? 0)}) products</span></Space>
                <div>
                    <Segmented onChange={(e) => setView(e)} value={view} size="small" options={[
                        {
                            value: 'details',
                            icon:
                                <Tooltip title="Detailed View">
                                    <PicLeftOutlined style={{ "fontSize": "13px" }} />
                                </Tooltip>,
                        },
                        {
                            value: 'list',
                            icon:
                                <Tooltip title="Brief View">
                                    <UnorderedListOutlined style={{ "fontSize": "13px" }} />
                                </Tooltip>,
                        },
                        {
                            value: 'cards',
                            icon:
                                <Tooltip title="Covers View">
                                    <AppstoreOutlined style={{ "fontSize": "13px" }} />
                                </Tooltip>,
                        },
                        ...(session.logged_in && !session.has_bm_data_lite ? [
                            {
                                value: 'calendar',
                                icon: <Tooltip title={<small>Compare previous edition side-by-side. <br />(Best for calendar purchasing)</small>}><CalendarOutlined style={{ "fontSize": "13px" }} /></Tooltip>,
                            }
                        ] : [])
                    ]}
                    />
                </div>
            </div>
            {drawContext()}
            <Spin spinning={loading}>
                <div>
                    <div><BrowseFilters view={view} getBrowse={() => fetchBrowse()} is_browse={true} loading={loading} sort={sort()} path={path} searchFilters={filters} setSearchFilters={setFilters} setFilters={setF} filters={f} /></div>


                    <Layout>
                        <Layout.Content style={{ "backgroundColor": "#fff" }}>
                            <Paginate key={"paginate-1"} max_offset={results.max_offset} count={results.row_count} paginate={pagination} setPaginate={(_p) => {
                                setPagination(_p)
                                history.push({ pathname: path + objectToPath({ ...filters, "l": _p.pagesize, "o": _p.offset }) });
                            }} />
                            <Divider key={"divider-1"} dashed style={{ "margin": "10px 0px", "marginRight": "0px", "width": "auto", "minWidth": "auto" }} />
                            <conditional.true value={(view === "calendar")}>
                                <div className="calendar-tag" style={{ "display": "flex", "justifyContent": "space-around" }}>
                                    <div>
                                        <small>Current Edition</small>
                                    </div>
                                    <div>
                                        <small>Previous Edition</small>
                                    </div>
                                </div>
                                <Divider style={{ "margin": "0px" }} />
                            </conditional.true>
                            {drawTitles()}
                            {(view === "list" && <div><div className="shim" /><div className="shim" /></div>)}
                            <Paginate key={"paginate-2"} max_offset={results.max_offset} count={results.row_count} paginate={pagination} setPaginate={(_p) => {
                                setPagination(_p)
                                history.push({ pathname: path + objectToPath({ ...filters, "l": _p.pagesize, "o": _p.offset }) });
                            }} />
                        </Layout.Content>
                    </Layout>
                </div>
            </Spin>
        </div>
    )
}